export const getDefaultSuccessMessage = (actionDesc, override) => {
    return override || `${actionDesc} was successful.`;
};
export const getDefaultErrorMessage = (actionDesc, override) => {
    return (
        override || `Sorry, we were unable to ${actionDesc}. Please try again.`
    );
};
